import { USER_TYPES } from '../../config/app.config';

export const STAFF_SORT_OPTIONS = [
  { value: 'fullName', label: 'Name', defaultOrder: 1 },
  { value: 'designation', label: 'Designation', defaultOrder: 1 },
  { value: 'type', label: 'Permissions', defaultOrder: 1 },
];

export const SUPER_ADMIN_STAFF_SORT_OPTIONS = [
  { value: 'facilityDisplayName', label: 'Facility', defaultOrder: 1 },
  { value: 'fullName', label: 'Name', defaultOrder: 1 },
  { value: 'designation', label: 'Designation', defaultOrder: 1 },
  { value: 'type', label: 'Permissions', defaultOrder: 1 },
];

export const STAFF_FILTER_SEARCH_THRESHOLD = 8;

export const STAFF_SECONDARY_NAME_SORT_FIELDS = [
  'designation',
  'type',
  'facilityDisplayName',
];

export function getStaffSortOptions({ isSuperAdmin = false } = {}) {
  return isSuperAdmin ? SUPER_ADMIN_STAFF_SORT_OPTIONS : STAFF_SORT_OPTIONS;
}

export function getStaffFilterCategories({
  designations = [],
  facilities = [],
} = {}) {
  const designationChoices = designations.map((designation) => ({
    value: designation.name,
    label: designation.name,
  }));
  designationChoices.push({ value: 'N/A', label: 'N/A' });

  const categories = [
    {
      key: 'designation',
      label: 'Designation',
      choices: designationChoices,
    },
    {
      key: 'type',
      label: 'Permissions',
      choices: [
        { value: USER_TYPES.ADMIN, label: 'Admin' },
        { value: USER_TYPES.STAFF, label: 'User' },
        { value: USER_TYPES.IPAD_ONLY, label: 'iPad Only' },
      ],
    },
    {
      key: 'privateCredentials',
      label: 'Credentials',
      choices: [
        { value: 'true', label: 'Private' },
        { value: 'false', label: 'Assigned' },
      ],
    },
    {
      key: 'status',
      label: 'Status',
      choices: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
    },
  ];

  if (facilities.length) {
    const facilityChoices = facilities
      .map((facility) => ({
        value: facility.id || facility._id,
        label: facility.name || facility.displayName,
      }))
      .sort((a, b) =>
        String(a.label || '').localeCompare(String(b.label || '')),
      );

    categories.unshift({
      key: 'facilities',
      label: 'Facility',
      choices: facilityChoices,
    });
  }

  return categories;
}
